import React, { useState } from 'react';
import { getSessionHeaders } from '../../lib/serverSession';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || '';

export const DatabaseTest: React.FC = () => {
  const [testResult, setTestResult] = useState<string>('');
  const [loading, setLoading] = useState(false);

  const testConnection = async () => {
    setLoading(true);
    setTestResult('Testing connection...');

    try {
      // Test basic connection via API
      const response = await fetch(`${API_BASE_URL}/api/admin/generic`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...getSessionHeaders() },
        body: JSON.stringify({
          operation: 'select',
          data: { table: 'admin_users', select: 'id', limit: 1 }
        })
      });
      const result = await response.json();

      if (!response.ok) {
        setTestResult(`❌ Connection failed: ${result.error}`);
      } else {
        setTestResult('✅ Database connection successful!');
      }
    } catch (err) {
      setTestResult(`❌ Error: ${err instanceof Error ? err.message : 'Unknown error'}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="glass-card-strong p-6">
      <h3 className="text-xl font-semibold text-gold-primary mb-4">Database Connection Test</h3>
      
      <button
        onClick={testConnection}
        disabled={loading}
        className="btn-primary mb-4"
      >
        {loading ? 'Testing...' : 'Test Database Connection'}
      </button>
      
      {testResult && (
        <div className="p-4 rounded-lg bg-black-soft border border-gray-600">
          <pre className="text-sm text-white whitespace-pre-wrap">{testResult}</pre>
        </div>
      )}
    </div>
  );
};
